import React, {useEffect} from 'react';
import {Route, Routes, Navigate, useLocation} from "react-router-dom";
import {routes} from "./routes";
import {
    SIGNIN_ROUTE,
    HOME_ROUTE,
    SIGNUP_ROUTE,
    STUDENTS_ROUTE,
    ADMIN
} from "./utils";
import {getRole, getToken} from "./utils/jwtUtils";
import {isTokenValid} from "./utils/authUtils";

const ScrollToTop = () => {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'instant'});
    }, [pathname]);

    return null;
};

const AppRouter = () => {

    const userRole = getRole();

    const hasAccess = (allowedRoles) => {
        if (!allowedRoles || allowedRoles.length === 0) return true;
        return allowedRoles.includes(userRole);
    };

    const PrivateRoute = ({children, allowedRoles}) => {
        const token = getToken();

        if (!isTokenValid(token)) {
            return <Navigate to={SIGNIN_ROUTE} replace/>;
        }

        const role = getRole();
        if (!role) return <div>Загрузка...</div>;

        if (!hasAccess(allowedRoles)) {
            return <Navigate to={role === ADMIN ? STUDENTS_ROUTE : HOME_ROUTE} replace/>;
        }

        return children;
    };

    const AuthRedirectWrapper = ({fallback}) => {
        const token = getToken();

        if (isTokenValid(token)) {
            try {
                const role = getRole();
                return <Navigate to={role === ADMIN ? STUDENTS_ROUTE : HOME_ROUTE} replace/>;
            } catch (e) {
                return fallback;
            }
        }

        return fallback;
    };

    return (
        <>
            <ScrollToTop/>
            <Routes>
                {routes.map(({path, Component, roles}) => {
                    if (path === SIGNIN_ROUTE || path === SIGNUP_ROUTE) {
                        return (
                            <Route
                                key={path}
                                path={path}
                                element={
                                    <AuthRedirectWrapper fallback={Component}/>
                                }
                                exact
                            />
                        );
                    }

                    return (
                        <Route
                            key={path}
                            path={path}
                            element={<PrivateRoute allowedRoles={roles}>{Component}</PrivateRoute>}
                            exact
                        />
                    );
                })}

                <Route path="*" element={<Navigate to={SIGNIN_ROUTE} replace/>}/>
            </Routes>
        </>
    );
};

export default AppRouter;